module.exports = __webpack_public_path__ + "static/media/finalDesign.04e3a018.png";